<template>
  <svg
    viewBox="0 0 1024 1024"
    class="upload-icon"
    :class="customizedClass !== '' && 'customizedClass'"
    :fill="color"
  >
    <path
      d="M512 598q108 0 225 47t117 123v86h-684v-86q0-76 117-123t225-47zM512 512q-70 0-120-50t-50-120 50-121 120-51 120 51 50 121-50 120-120 50z"
    ></path>
  </svg>
</template>
<script>
/**
 * @description Componente que exibe o icone de upload
 */
export default {
  name: "UploadIcon",
  props: {
    color: {
      type: String,
      default: "white",
    },
    customizedClass: {
      type: String,
      default: "",
    },
  },
};
</script>
<style scoped>
.upload-icon {
  height: 1.5rem;
  width: 1.5rem;
}
</style>
